module.exports = __webpack_public_path__ + "img/cert_icon_white.ce555e6c.svg";